import * as React from 'react';

function SvgCreateTips(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19" {...props}>
      <g fill="none">
        <path
          d="M5.519 12.599C3.638 11.564 2.384 9.682 2.384 7.53c.002-3.268 2.893-5.916 6.463-5.916 3.569 0 6.46 2.648 6.46 5.914 0 2.15-1.255 4.035-3.134 5.068a2.94 2.94 0 01-.718 1.407H6.237a2.96 2.96 0 01-.718-1.405zm7.944-4.507c.015-2.471-2.052-4.487-4.616-4.504-.409 0-.616.19-.616.562 0 .093.207.28.616.28 1.97 0 3.692 1.578 3.692 3.662 0 .093.208.282.614.282.103 0 .31-.189.31-.282zm-7.386 7.32c0-.31.275-.56.614-.56H11c.34 0 .613.248.613.56s-.275.563-.613.563H6.692a.606.606 0 01-.427-.157.574.574 0 01-.188-.406zm5.25 1.41c-.452.833-1.394 1.408-2.48 1.408-1.034.011-1.99-.53-2.481-1.407z"
          fill="#fedd48"
        />
        <path
          d="M7 .692c3.57 0 6.461 2.648 6.461 5.914 0 2.15-1.256 4.035-3.134 5.068a2.94 2.94 0 01-.718 1.407H4.39a2.96 2.96 0 01-.718-1.406C1.792 10.641.538 8.76.538 6.607.54 3.34 3.431.692 7 .692zm0 1c-3.035 0-5.46 2.22-5.462 4.915 0 1.723.996 3.3 2.616 4.192l.406.223.092.453c.044.214.123.419.235.606h4.225l.079-.144c.072-.146.123-.299.155-.457l.09-.458.409-.225c1.619-.89 2.616-2.469 2.616-4.191 0-2.694-2.425-4.914-5.46-4.914zm2.155 12.237c.34 0 .613.248.613.56s-.275.563-.613.563H4.846a.606.606 0 01-.427-.157.574.574 0 01-.188-.406c0-.31.275-.56.613-.56zm.326 1.97c-.452.833-1.394 1.408-2.48 1.408-1.034.011-1.99-.53-2.481-1.407z"
          fill="#4c4c4c"
        />
      </g>
    </svg>
  );
}

export default SvgCreateTips;
